<template>
  <div>
    <Top />
    <div class="home obors">
      <h2 class="bt_title">中国全球投资跟踪数据库</h2>
    </div>

    <!-- 子库切换悬窗 -->
    <div class="izl-rmenu" v-show="is_rmenushow" @mouseover="showfloatdb">
      <div id="db1" class="btn btntext btntext1 company1 on1" @click="cgit_i">
        <span>对外直接投资</span>
      </div>
      <div id="db2" class="btn btntext btntext2 company2" @click="cgit_c">
        <span class="btntextspan">工程项目</span>
      </div>
      <div id="db3" class="btn btntext btntext3 company3" @click="cgit_f">
        <span class="btntextspan">失败项目</span>
      </div>
      <div
        @click="hidefloatdb"
        style="text-align: right; padding: 2px; font-size: 12px; cursor: pointer;"
        class="closeFloatl0"
      >隐藏</div>
    </div>

    <!-- 下拉框 -->
    <div class="home m15 screenbox p5 clearfix">
      <div id="searchBar" :class="searchBarFixed == true ? 'searchBar' :''">
        <ul class="screen">
          <li class="width20 fl">
            <el-select
              v-model="sectorsvalue"
              @change="sectorsInput"
              filterable
              placeholder="全部行业"
              size="medium"
            >
              <el-option
                v-for="item in sectors"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li class="width20 fl">
            <div class="wrap">
              <SelectTree
                ref="seleTree"
                :inputName="country"
                :props="props"
                :options="optionData"
                :options1="optionData1"
                :options2="optionData2"
                :options3="optionData3"
                :clearable="isClearable"
                :accordion="isAccordion"
                @getValue="getValue($event)"
              />
            </div>
          </li>
          <li class="width20 fl">
            <el-select v-model="yearsvalue" @change="yearsInput" filterable size="medium">
              <el-option
                v-for="item in years"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li class="width20 fl" v-show="investshow">
            <el-select
              v-model="investsvalue"
              @change="investInput"
              filterable
              placeholder="绿地投资"
              size="medium"
            >
              <el-option
                v-for="item in invests"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li class="width20 fl">
            <el-select
              v-model="quantitysvalue"
              @change="quantitysInput"
              filterable
              placeholder="全部项目金额"
              size="medium"
            >
              <el-option
                v-for="item in quantitys"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li class="width20 fl" v-show="sharesshow">
            <el-select
              v-model="sharesvalue"
              @change="sharesInput"
              filterable
              placeholder="全部股权比例"
              size="medium"
            >
              <el-option
                v-for="item in shares"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li class="widthreset fl">
            <el-button @click="resetsearch" style="height:36px;">重置</el-button>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
    </div>

    <!-- 流向图  -->
    <div class="mapbox">
      <div class="bj_white2 home">
        <!-- 流向图 -->
        <div class="echarts">
          <div :style="{height:'825px',width:'100%'}" ref="myEchart" id="myEchart"></div>

          <div class="mapboxsource">
            <div class="fl">来源：美国企业研究所</div>
            <br />
            <!-- <div class="fl">注：2022年数据更新至2022年6月</div> -->
          </div>
          <div class="mapboxdownload">
            <div>2026年数据截至6月份</div>
            <el-button type="primary" plain @click="downloadexcel">表格下载</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 4个图 -->
    <div class="home p5 clearfix">
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>中国对外{{charttitle1}}{{charttitle4_6}}</h1>
          </div>
          <div class="zoomBtn" @click="openFullscreen('1')"></div>
          <div id="c1">
            <c-chart
              v-show="chart1_1"
              id="chart1"
              ref="chart1"
              :option="option1"
              :style="{margin:'0 auto',height:'260px'}"
            ></c-chart>
            <img
              v-show="chart1_2"
              src="../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:260px;"
            />
          </div>
        </div>
      </div>
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>{{selectyear}}年中国对{{charttitle2_1}}{{charttitle2_2}}的行业分布</h1>
          </div>
          <div class="zoomBtn" @click="openFullscreen('2')"></div>
          <c-chart
            v-show="chart2_1"
            id="chart2"
            :option="option2"
            :style="{margin:'0 auto',height:'260px'}"
          ></c-chart>
          <img
            v-show="chart2_2"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:260px;"
          />
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="home p5 clearfix">
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>{{selectyear}}年中国{{charttitle3_0}}对外{{charttitle3_1}}的区域分布</h1>
          </div>
          <div class="zoomBtn" @click="openFullscreen('3')"></div>
          <c-chart
            v-show="chart3_1"
            id="chart3"
            :option="option3"
            :style="{margin:'0 auto',height:'260px'}"
          ></c-chart>
          <img
            v-show="chart3_2"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:260px;"
          />
        </div>
      </div>
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1
              id="chart4_1_h1"
            >{{selectyear}}年中国对{{charttitle4_1}}{{charttitle4_2}}{{charttitle4_3}}TOP{{option4topnum}}的{{charttitle4_5}}{{charttitle4_6}}</h1>
          </div>
          <div class="zoomBtn" @click="openFullscreen('4')"></div>
          <c-chart
            v-show="chart4_1"
            id="chart4"
            :option="option4"
            :style="{margin:'0 auto',height:'260px'}"
          ></c-chart>
          <img
            v-show="chart4_2"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:260px;"
          />
        </div>
      </div>
      <div class="clear"></div>
    </div>

    <!-- 饼图 -->
    <div :style="{display: pieDisplay}">
      <div class="home p5 clearfix">
        <div class="w33 fl">
          <div class="box1 bj_white2">
            <div class="card_title">
              <h1 id="chart5_h1">{{selectyear}}年中国{{charttitle5_1}}{{charttitle5_2}}直接投资规模分布（按项目个数）</h1>
            </div>
            <div class="zoomBtn" @click="openFullscreen('5')"></div>
            <c-chart
              v-show="pieDisplay1_1"
              id="chart5"
              :option="option5"
              :style="{margin:'0 auto',height:'330px'}"
            ></c-chart>
            <img
              v-show="pieDisplay1_2"
              src="../../assets/imgs/piedefault.png"
              style="margin:0 auto; height:330px;"
            />
          </div>
        </div>
        <div class="w33 fl">
          <div class="box1 bj_white2">
            <div class="card_title">
              <h1 id="chart6_h1">{{selectyear}}年中国{{charttitle6_1}}{{charttitle6_2}}直接投资股权占比（按项目个数）</h1>
            </div>
            <div class="zoomBtn" @click="openFullscreen('6')"></div>
            <c-chart
              v-show="pieDisplay2_1"
              id="chart6"
              :option="option6"
              :style="{margin:'0 auto',height:'330px'}"
            ></c-chart>
            <img
              v-show="pieDisplay2_2"
              src="../../assets/imgs/piedefault.png"
              style="margin:0 auto; height:330px;"
            />
          </div>
        </div>
        <div class="w33 fl">
          <div class="box1 bj_white2">
            <div class="card_title">
              <h1
                id="chart7_h1"
              >{{selectyear}}年中国{{charttitle7_1}}{{charttitle7_2}}直接投资中绿地投资项目占比（按项目个数）</h1>
            </div>
            <div class="zoomBtn" @click="openFullscreen('7')"></div>
            <c-chart
              v-show="pieDisplay3_1"
              id="chart7"
              :option="option7"
              :style="{margin:'0 auto',height:'330px'}"
            ></c-chart>
            <img
              v-show="pieDisplay3_2"
              src="../../assets/imgs/piedefault.png"
              style="margin:0 auto; height:330px;"
            />
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <!-- 柱图下钻弹出框 -->
    <div class="historySupBox" :style="{display: boxDisplay}">
      <div class="maskBox"></div>
      <div class="historyAlertBox">
        <div class="alerttitle">{{alerttitle}}</div>
        <div class="historyAlertBox_close" @click="closeAlert"></div>
        <div class="historyAlertBox_data"></div>
        <div class="historyAlertBox_main" id="historyContainer" style="width: 100%; height: 100%;">
          <cChart
            id="chart8"
            :option="option8"
            :style="{margin:'0 auto',height:'50vh',width:'47vw'}"
          ></cChart>
        </div>
      </div>
    </div>

    <!-- 放大框 -->
    <div class="alertBox" style="display:none" :class="{open:isOpen}" v-show="showAlertBox">
      <!-- 关闭标签 -->
      <div class="narrowBtn" @click="closeFullscreen"></div>
      <!-- 标题 -->
      <div class="fullscreentitle">{{fullscreentitie}}</div>
      <!-- 放入图表 -->
      <div
        data-v-c59e794e
        id="chartfullscreen"
        _echarts_instance_="ec_1573637798184"
        style="height: 100vh; width: 98vw; margin: 0px auto; -webkit-tap-highlight-color: transparent; user-select: none; position: relative;"
      ></div>
    </div>
    <backTop />

    <Footer />
  </div>
</template>
<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
import backTop from "@/components/BackTop";
import echarts from "echarts";
// import "../../../node_modules/echarts/map/js/world.js";
import { initCharts, formatNum } from "../../assets/js/world_CGIT.js";
import cChart from "./cgit_chart.vue";
import SelectTree from "@/components/treeSelect.vue";
import { api } from "@/require/api";

export default {
  name: "cgit",
  data() {
    return {
      is_rmenushow: true, //子库切换的悬窗
      country: "全部经济体",
      optionData: [], //"所有区域"下拉框
      optionData1: [], //"所有区域"下拉框
      optionData2: [], //"所有区域"下拉框
      optionData3: [], //"所有区域"下拉框
      //"所有区域"下拉框
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）

      props: {
        // 配置项（必选）
        value: "value",
        label: "name",
        children: "children"
      },
      searchBarFixed: false, //下拉搜索框
      boxDisplay: "none", //柱图下钻弹出框
      investshow: true, //"绿地投资"下拉框
      sharesshow: true, //"控股比例"下拉框

      chart1_1: true, //图1
      chart1_2: false, //图1默认图
      chart2_1: true, //图2
      chart2_2: false, //图2默认图
      chart3_1: true, //图3
      chart3_2: false, //图3默认图
      chart4_1: true, //图4
      chart4_2: false, //图4默认图

      pieDisplay: false, //3个饼
      pieDisplay1_1: true, //第一个饼
      pieDisplay1_2: false, //第一个饼默认图
      pieDisplay2_1: true, //第二个饼
      pieDisplay2_2: false, //第二个饼默认图
      pieDisplay3_1: true, //第三个饼
      pieDisplay3_2: false, //第三个饼默认图
      // 放大
      isOpen: false,
      showAlertBox: false,
      fullscreenoptionid: 1, //放大哪个option
      fullscreentitie: "", //放大的标题
      //子库切换
      isOnhover_i: true,
      isOnhover_c: false,
      isOnhover_f: false,
      databaseid: 1,
      //echart标题
      databasename: "投资",
      charttitle1: "直接投资总额年度变化趋势",
      charttitle2_1: "外",
      charttitle2_2: "直接投资",
      charttitle3_0: "",
      charttitle3_1: "直接投资",

      option4topnum: 10,
      charttitle4_1: "外",
      charttitle4_2: "直接投资",
      charttitle4_3: "",
      charttitle4_4: "",
      charttitle4_5: "投资方（按项目单笔金额排名）",
      charttitle4_6: "",

      charttitle5_1: "对外", //xx国家
      charttitle5_2: "", //xx行业
      charttitle6_1: "对外",
      charttitle6_2: "",
      charttitle7_1: "对外",
      charttitle7_2: "",
      //流向图
      worldData: [],
      geoCoordMapdata: {},
      exceldata: [],
      //下拉
      countryid: "", //下拉所有区域value
      countryname: "", //下拉所有区域value
      tabnum: 0, //下拉所有区域是否有下级，true是一级，false是二级
      valuelayer: false,
      sectors: [], //提示项
      sectorsvalue: "", //下拉值，即placeholder
      sectorsname: "", //下拉值，为了显示下边图的标题
      years: [],
      yearsvalue: "",
      invests: [],
      investsvalue: "",
      investsname: "全部投资", //下拉值，为了显示下边图的标题
      quantitys: [],
      quantitysvalue: "",
      quantitysname: "全部项目金额", //下拉值，为了显示下边图的标题
      shares: [],
      sharesvalue: "",
      sharesname: "全部股权比例", //下拉值，为了显示下边图的标题
      //选中值value
      selectsector: "",
      selectyear: "",
      selectinvest: "",
      selectquantity: "",
      selectshare: "",
      //柱图下钻二级值-因为接口一次性返回了，所以先保存，下钻时使用
      option2sub: [],
      option3sub: [],
      alerttitle: "",

      //图1接口返回的饼图数据集合
      alloption1data: [],

      //图配置项
      option1: {
        title: [
          {
            text: "单位：亿美元",
            x: "right",
            padding: [10, 40, 0, 0],
            textStyle: {
              fontSize: 12,
              fontWeight: "normal",
              color: "#333"
            }
          }
        ],
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: { gridIndex: 0 },
        grid: { top: "25%" },
        series: [
          {
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
            data: [],
            itemStyle: {
              normal: {
                color: "#3399ff",
                lineStyle: {
                  color: "#FF8247"
                }
              }
            }
          },
          {
            type: "pie",
            id: "pie",
            radius: "30%",
            center: ["41%", "25%"],
            label: {
              normal: {
                formatter: function(params) {
                  //三位分隔法
                  var intPartFormat = params.value
                    .toString()
                    .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
                  return (
                    params.name +
                    "：" +
                    intPartFormat +
                    "(" +
                    params.percent +
                    "%)"
                  );
                }
              }
            },
            data: this.optiondata1,
            encode: {
              itemName: "product"
            },
            itemStyle: {
              normal: {
                borderWidth: 2, //饼图各区域之间的间隔
                borderColor: "#ffffff",
                color: function(params) {
                  let colorList = [
                    "#47aeee",
                    "#777bc9",
                    "#34a556",
                    "#89c05e",
                    "#bed647",
                    "#ff6565",
                    "#2c5ca7",
                    "#efc81e",
                    "#e0851f",
                    "#34acb0",
                    "#a074b7",
                    "#ef5b9c",
                    "#e94c42"
                  ];
                  return colorList[params.dataIndex];
                }
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      option2: {
        title: [
          {
            text: "",
            x: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "normal",
              color: "#333",
              fontFamily: "微软雅黑"
            }
          },
          {
            text: "单位：亿美元",
            x: "right",
            padding: [10, 40, 0, 0],
            textStyle: {
              fontSize: 12,
              fontWeight: "normal",
              color: "#333"
            }
          }
        ],
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "shadow"
            type: "none"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: "value"
            // scare:true
            //  minInterval:100,
            //  maxInterval:2000,
          }
        ],
        series: [
          {
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#FF8247" },
                  { offset: 0.7, color: "#FF6247" },
                  { offset: 1, color: "#FF4247" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#FF4247" },
                  { offset: 0.5, color: "#FF6247" },
                  { offset: 1, color: "#FF8247" }
                ])
              }
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: "#666"
              }
            },
            name: "",
            type: "bar",
            barWidth: "50%",
            data: []
          }
        ]
      },
      option3: {
        title: [
          {
            text: "",
            x: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "normal",
              color: "#333",
              fontFamily: "微软雅黑"
            }
          },
          {
            text: "单位：亿美元",
            x: "right",
            padding: [10, 40, 0, 0],
            textStyle: {
              fontSize: 12,
              fontWeight: "normal",
              color: "#333"
            }
          }
        ],
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "shadow"
            type: "none"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#87cefa" },
                  { offset: 1, color: "#47aeee" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#47aeee" },
                  { offset: 1, color: "#87cefa" }
                ])
              }
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: "#666"
              }
            },
            name: "",
            type: "bar",
            barWidth: "50%",
            data: []
          }
        ]
      },
      option4: {
        title: [
          {
            text: "",
            x: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "normal",
              color: "#333",
              fontFamily: "微软雅黑"
            }
          },
          {
            text: "单位：亿美元",
            x: "right",
            padding: [10, 40, 0, 0],
            textStyle: {
              fontSize: 12,
              fontWeight: "normal",
              color: "#333"
            }
          }
        ],
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: [
          {
            height: "85%",
            top: "8%",
            left: "35%",
            bottom: "11%"
          },
          {
            height: "85%",
            top: "8%",
            left: "35%",
            bottom: "11%"
          }
        ],
        xAxis: [
          {
            splitLine: {
              show: false
            }
          },
          {
            gridIndex: 1
          }
        ],
        yAxis: [
          {
            data: [],
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 0
            }
          },
          {
            gridIndex: 1
          }
        ],
        series: [
          {
            name: "",
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "right",
                textStyle: {
                  fontSize: 12,
                  fontWeight: "normal",
                  color: "#666"
                },
                formatter: function(param) {
                  return param.value;
                }
              }
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#22aaf1" },
                  { offset: 1, color: "#22cef1" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#22cef1" },
                  { offset: 1, color: "#22aaf1" }
                ])
              }
            },
            barWidth: 10,
            data: []
          }
        ]
      },
      option5: {
        title: {
          text: "",
          x: "right",
          padding: [10, 40, 0, 0],
          textStyle: {
            fontSize: 12,
            fontWeight: "normal",
            color: "#333"
          }
        },
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} :<br/> 项目个数{c}个；<br/>占比{d}%"
        },
        legend: {
          orient: "horizontal",
          left: "left",
          data: [],
          width: "95%"
        },
        series: [
          {
            type: "pie",
            radius: "55%",
            center: ["55%", "60%"],
            data: [],
            itemStyle: {
              normal: {
                borderWidth: 2, //饼图各区域之间的间隔
                borderColor: "#ffffff",
                color: function(params) {
                  let colorList = [
                    "#4ea9ee",
                    "#6170c8",
                    "#1db0be",
                    "#4ba566",
                    "#e78633",
                    "#e65545",
                    "#89c05e",
                    "#efc31a",
                    "#25a399",
                    "#ff7b7b",
                    "#dd5582",
                    "#9a63a9"
                  ];
                  return colorList[params.dataIndex];
                }
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      option6: {
        title: {
          text: "注：“未知”指数据不详的数据。",
          x: "right",
          y: "bottom",
          padding: [0, 0, 5, 0],
          textStyle: {
            fontSize: 12,
            fontWeight: "normal",
            color: "#333"
          }
        },
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : <br/> 项目个数{c}个；<br/> 占比{d}%"
        },
        legend: {
          orient: "horizontal",
          left: "left",
          data: [],
          width: "95%"
        },
        series: [
          {
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [],
            itemStyle: {
              normal: {
                borderWidth: 2, //饼图各区域之间的间隔
                borderColor: "#ffffff",
                color: function(params) {
                  let colorList = [
                    "#4ea9ee",
                    "#6170c8",
                    "#1db0be",
                    "#4ba566",
                    "#e78633",
                    "#e65545",
                    "#89c05e",
                    "#efc31a",
                    "#25a399",
                    "#ff7b7b",
                    "#dd5582",
                    "#9a63a9"
                  ];
                  return colorList[params.dataIndex];
                }
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      option7: {
        title: {
          text: "",
          x: "right",
          padding: [10, 40, 0, 0],
          textStyle: {
            fontSize: 12,
            fontWeight: "normal",
            color: "#333"
          }
        },
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} :<br/> 项目个数{c}个；<br/>占比{d}%"
        },
        legend: {
          orient: "horizontal",
          left: "left",
          data: [],
          width: "95%"
        },
        series: [
          {
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [],
            itemStyle: {
              normal: {
                borderWidth: 2, //饼图各区域之间的间隔
                borderColor: "#ffffff",
                color: function(params) {
                  let colorList = [
                    "#4ea9ee",
                    "#6170c8",
                    "#1db0be",
                    "#4ba566",
                    "#e78633",
                    "#e65545",
                    "#89c05e",
                    "#efc31a",
                    "#25a399",
                    "#ff7b7b",
                    "#dd5582",
                    "#9a63a9"
                  ];
                  return colorList[params.dataIndex];
                }
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      option8: {
        toolbox: {
          padding: [5, 20, 0, 0],
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        title: [
          {
            text: "",
            x: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "normal",
              color: "#333",
              fontFamily: "微软雅黑"
            }
          },
          {
            x: "center",
            top: "10",
            bottom: "20",
            textStyle: {
              fontSize: 15
            }
          }
        ],
        color: ["#66ccff"],
        legend: {
          width: "100%",
          height: "100%",
          show: true
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: "{c}",
                textStyle: {
                  color: "#000"
                }
              }
            },
            name: "",
            type: "bar",
            barWidth: "50%",
            data: []
          }
        ]
      }
    };
  },
  created() {
    this.getCGITSelect(); //下拉
  },
  methods: {
    //隐藏子库切换
    hidefloatdb() {
      $(".izl-rmenu").css("left", "-70px");
      $(".izl-rmenu").css("-webkit-transition", "all .4s");
      $(".izl-rmenu").css("transition", "all .4s");
      $(".closeFloatl0").css("text-align", "left");
    },
    //显示子库切换
    showfloatdb() {
      $(".izl-rmenu").css("left", "0px");
      $(".izl-rmenu").css("-webkit-transition", "all .4s");
      $(".izl-rmenu").css("transition", "all .4s");
      $(".closeFloatl0").css("text-align", "right");
    },
    //重置
    resetsearch() {
      this.sectorsvalu = "全部行业";
      this.country = "全部经济体";
      this.yearsvalue = "2019";
      this.selectyear = "2019";
      this.investsvalue = "绿地投资";
      this.quantitysvalue = "全部项目金额";
      this.sharesvalue = "全部股权比例";

      if (this.databasename == "投资") {
        this.charttitle1 = "直接投资总额年度变化趋势";
        this.charttitle2_1 = "外";
        this.charttitle2_2 = "直接投资";

        this.charttitle3_0 = "";
        this.charttitle3_1 = "直接投资";

        (this.charttitle4_1 = "外"),
          (this.charttitle4_2 = "直接投资"),
          (this.charttitle4_4 = "");
        this.charttitle4_5 = "投资方（按项目单笔金额排名）";
        this.againSelect();
      } else if (this.databasename == "承包工程项目") {
        this.charttitle1 = "承包工程项目金额年度变化趋势";
        this.charttitle2_1 = "外";
        this.charttitle2_2 = "承包工程项目";
        this.charttitle3_0 = "";
        this.charttitle3_1 = "承包工程项目";

        this.option4topnum = 10;
        this.charttitle4_1 = "外";
        this.charttitle4_2 = "承包工程项目";
        this.charttitle4_3 = "单笔金额排名";
        this.charttitle4_4 = "TOP10";
        this.charttitle4_5 = "企业";
        this.againSelect2();
        // this.option8.title[0].text = '全部项目金额';
      } else if (this.databasename == "直接投资失败项目") {
        this.charttitle1 = "直接投资失败项目所涉金额";
        this.charttitle2_1 = "外";
        this.charttitle2_2 = "直接投资失败项目";
        this.charttitle3_0 = "";
        this.charttitle3_1 = "直接投资失败项目";

        this.option4topnum = 10;
        this.charttitle4_1 = "外";
        this.charttitle4_2 = "直接投资失败项目";
        this.charttitle4_3 = "单笔金额排名";
        this.charttitle4_4 = "TOP1";
        this.charttitle4_5 = "企业";
        this.againSelect2();
        // this.option8.title[0].text = '全部项目金额';
      }
      this.charttitle4_6 = "";
      this.charttitle5_1 = "对外";
      this.charttitle5_2 = "";
      this.charttitle6_1 = "对外";
      this.charttitle6_2 = "";
      this.charttitle7_1 = "对外";
      this.charttitle7_2 = "";
    },
    // 下拉搜索固定
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.getElementById("searchBar").offsetTop;
      scrollTop > offsetTop
        ? (this.searchBarFixed = true)
        : (this.searchBarFixed = false);
    },
    //子库切换
    //投资
    cgit_i() {
      $("#db1").addClass("on1");
      $("#db2").removeClass("on2");
      $("#db3").removeClass("on3");
      this.databasename = "投资";
      this.charttitle1 = "直接投资总额年度变化趋势";
      this.charttitle2_1 = "外";
      this.charttitle2_2 = "直接投资";
      this.charttitle3_0 = "";
      this.charttitle3_1 = "直接投资";
      this.charttitle4_1 = "外";
      this.charttitle4_2 = "直接投资";
      //this.charttitle4_3 = "单笔金额排名";
      //this.charttitle4_4 = "TOP10";
      //this.charttitle4_5 = "企业";

      (this.charttitle4_3 = ""), (this.charttitle4_4 = "TOP10");
      this.charttitle4_5 = "投资方（按项目单笔金额排名）";
      //charttitle4_6: "",

      (this.isOnhover_i = true),
        (this.isOnhover_c = false),
        (this.isOnhover_f = false),
        (this.investshow = true),
        (this.sharesshow = true),
        (this.pieDisplay = "block"),
        (this.databaseid = 1),
        // this.getCGITSelect(); //下拉
        this.againSelect();
      this.charttitle4_6 = "";
      this.charttitle5_1 = "对外";
      this.charttitle5_2 = "";
      this.charttitle6_1 = "对外";
      this.charttitle6_2 = "";
      this.charttitle7_1 = "对外";
      this.charttitle7_2 = "";
      this.option8.title[0].text =
        "（" +
        this.investsname +
        "，" +
        this.quantitysname +
        "，" +
        this.sharesname +
        "）";
    },
    //工程
    cgit_c() {
      $("#db1").removeClass("on1");
      $("#db2").addClass("on2");
      $("#db3").removeClass("on3");
      this.databasename = "承包工程项目";
      this.charttitle1 = "承包工程项目金额年度变化趋势";
      this.charttitle2_1 = "外";
      this.charttitle2_2 = "承包工程项目";
      this.charttitle3_0 = "";
      this.charttitle3_1 = "承包工程项目";
      this.charttitle4_1 = "外";
      this.charttitle4_2 = "承包工程项目";
      //this.charttitle4_3 = "单笔金额排名";
      //this.charttitle4_4 = "TOP10";
      //this.charttitle4_5 = "企业";

      (this.charttitle4_3 = ""), (this.charttitle4_4 = "TOP10");
      this.charttitle4_5 = "承包方（按项目单笔金额排名）";

      (this.isOnhover_i = false),
        (this.isOnhover_c = true),
        (this.isOnhover_f = false),
        (this.sharesshow = false),
        (this.investshow = false), //“绿地投资”
        (this.pieDisplay = "none"),
        (this.databaseid = 2),
        // this.getCGITSelect(); //下拉
        this.againSelect2();
      this.charttitle4_6 = "";
      this.charttitle5_1 = "对外";
      this.charttitle5_2 = "";
      this.charttitle6_1 = "对外";
      this.charttitle6_2 = "";
      this.charttitle7_1 = "对外";
      this.charttitle7_2 = "";
      this.option8.title[0].text = "（" + this.quantitysname + "）";
    },
    //失败工程
    cgit_f() {
      $("#db1").removeClass("on1");
      $("#db2").removeClass("on2");
      $("#db3").addClass("on3");
      this.databasename = "直接投资失败项目";
      this.charttitle1 = "直接投资失败项目所涉金额";
      this.charttitle2_1 = "外";
      this.charttitle2_2 = "直接投资失败项目";
      this.charttitle3_0 = "";
      this.charttitle3_1 = "直接投资失败项目";
      this.charttitle4_1 = "外";
      this.charttitle4_2 = "直接投资失败项目";
      // this.charttitle4_3 = "单笔金额排名";
      // this.charttitle4_4 = "TOP1";
      // this.charttitle4_5 = "企业";

      (this.charttitle4_3 = ""), (this.charttitle4_4 = "TOP10");
      this.charttitle4_5 = "投资方（按项目单笔金额排名）";

      (this.isOnhover_i = false),
        (this.isOnhover_c = false),
        (this.isOnhover_f = true),
        (this.investshow = false),
        (this.sharesshow = false), //“控股比例”
        (this.pieDisplay = "none"),
        (this.databaseid = 3),
        // this.getCGITSelect(); //下拉
        this.againSelect2();
      this.charttitle4_6 = "";
      this.charttitle5_1 = "对外";
      this.charttitle5_2 = "";
      this.charttitle6_1 = "对外";
      this.charttitle6_2 = "";
      this.charttitle7_1 = "对外";
      this.charttitle7_2 = "";
      this.option8.title[0].text = "（" + this.quantitysname + "）";
    },
    // 区域
    getValue(value) {
      this.countryname = value.split(",")[0];

      if (this.countryname.indexOf("全部经济体") != -1) {
        //图2
        this.charttitle2_1 = "外";
        //图4
        this.charttitle4_1 = "外";
        //3个饼图:全部经济体、全部行业时
        if (this.sectorsname == "" || this.sectorsname == "全部") {
          this.charttitle5_1 = "对外";
          this.charttitle6_1 = "对外";
          this.charttitle7_1 = "对外";
        }
        //3个饼图:全部经济体、非全部行业时
        else {
          this.charttitle5_1 = "";
          this.charttitle6_1 = "";
          this.charttitle7_1 = "";
        }
      } else {
        if (this.countryname == "全部一带一路经济体") {
          this.countryname = "全部经济体";
        }
        if (
          this.countryname.indexOf("（") > 0 ||
          this.countryname.indexOf("(") > 0
        ) {
          this.countryname = this.countryname.split("（")[0].split("(")[0];
        }

        //图2
        this.charttitle2_1 = this.countryname;
        //图2
        this.charttitle4_1 = this.countryname;

        //3个饼图:非全部经济体时
        this.charttitle5_1 = "对" + this.countryname;
        this.charttitle6_1 = "对" + this.countryname;
        this.charttitle7_1 = "对" + this.countryname;
      }

      this.countryid = value.split(",")[1];
      this.tabnum = value.split(",")[2];
      this.valuelayer = value.split(",")[3]; //是否有儿子，true表示有儿子，如果是false,tabnum需要设置为0

      if (this.valuelayer == "false") this.tabnum = 0;
      //要求选"一带一路国家和地区"中的"全部一带一路经济体时querytype传3
      if (value.split(",")[0] == "全部一带一路经济体") this.tabnum = 3;

      this.loaddata(); //刷新页面图
    },
    //点击下拉后刷新页面
    sectorsInput(value) {
      this.selectsector = value; //给下拉赋选择的值
      this.loaddata(); //刷新页面图
      var obj = {};
      obj = this.sectors.find(item => {
        return item.value === value;
      });
      this.sectorsname = obj.name; //下拉label值

      if (this.sectorsname == "全部行业") {
        this.sectorsname = "全部";

        //3个饼图：全部行业、全部经济体时
        if (
          this.countryname == "" ||
          this.countryname.indexOf("全部经济体") != -1
        ) {
          this.charttitle5_1 = "对外";
          this.charttitle6_1 = "对外";
          this.charttitle7_1 = "对外";
        }
        this.charttitle3_0 = "";
        //3个饼图：全部行业时
        this.charttitle5_2 = "";
        this.charttitle6_2 = "";
        this.charttitle7_2 = "";
      } else {
        //3个饼图：非全部行业、是全部经济体时
        if (
          this.countryname == "" ||
          this.countryname.indexOf("全部经济体") != -1
        ) {
          this.charttitle5_1 = "";
          this.charttitle6_1 = "";
          this.charttitle7_1 = "";
        }

        this.charttitle3_0 = this.sectorsname + "行业";

        this.charttitle5_2 = this.sectorsname + "行业";
        this.charttitle6_2 = this.sectorsname + "行业";
        this.charttitle7_2 = this.sectorsname + "行业";
      }

      this.charttitle4_6 = "（" + this.sectorsname + "行业）";

      if (this.sectorsname == "全部") {
        if (this.databaseid == 1) this.charttitle3_1 = "直接投资";
        else if (this.databaseid == 2) this.charttitle3_1 = "承包工程项目";
        else if (this.databaseid == 3) this.charttitle3_1 = "直接投资失败项目";

        this.charttitle4_6 = "";
      }
    },
    yearsInput(value) {
      this.yearsvalue = value + "";
      this.selectyear = value + "";
      this.loaddata();
    },
    investInput(value) {
      this.selectinvest = value;
      this.loaddata();

      var objinvest = {};
      objinvest = this.invests.find(item => {
        return item.value === value;
      });
      this.investsname = objinvest.name; //下拉label值
    },
    quantitysInput(value) {
      this.selectquantity = value;
      this.loaddata();

      var objquantity = {};
      objquantity = this.quantitys.find(item => {
        return item.value === value;
      });
      this.quantitysname = objquantity.name; //下拉label值
    },
    sharesInput(value) {
      this.selectshare = value;
      this.loaddata();

      var objshare = {};
      objshare = this.shares.find(item => {
        return item.value === value;
      });
      this.sharesname = objshare.name; //下拉label值
    },
    //绑定所有下拉值
    async getCGITSelect() {
      const { code, data } = await api.get("/cgitController/getDbInfo", {
        dbid: this.databaseid
      });
      if (code === 0) {
        this.sectors = data.sectors; //下拉值
        this.sectorsvalue = "全部行业";
        this.selectsector = 0; //下拉选择值，默认全部即0
        if (this.selectsector === 0) {
          this.sectorsname = "全部";
        }
        this.years = data.years;
        this.yearsvalue = data.years[0].name + "";
        this.selectyear = data.years[0].name + "";
        this.invests = data.green;
        this.investsvalue = "全部投资";
        this.selectinvest = 0;
        this.quantitys = data.quantitys;
        this.quantitysvalue = "全部项目金额";
        this.selectquantity = 0;
        this.shares = data.shares;
        this.sharesvalue = "全部股权比例";
        this.selectshare = 0;

        //全部经济体：经济体countrys、地区areas、经济组织groups、一带一路国家和地区ydylCountrys
        this.optionData = data.countrys;
        this.optionData1 = data.areas;
        this.optionData2 = data.groups;
        this.optionData3 = data.ydylCountrys;

        this.$refs.seleTree.valueTitle = "全部经济体"; //初始化下拉文本值
        this.countryid = 0; //初始化下拉值
        this.loaddata(); //加载数据
        this.chartevent(); //线饼图、柱图下钻
      }
    },
    // 重置用到
    async againSelect() {
      const { code, data } = await api.get("/cgitController/getDbInfo", {
        dbid: this.databaseid
      });
      if (code === 0) {
        this.sectors = data.sectors; //下拉值
        this.sectorsvalue = "全部行业";
        this.selectsector = 0; //下拉选择值，默认全部即0
        if (this.selectsector === 0) {
          this.sectorsname = "全部";
        }
        this.years = data.years;
        this.yearsvalue = data.years[0].name + "";
        this.selectyear = data.years[0].name + "";
        this.invests = data.green;
        this.investsvalue = "全部投资";
        this.selectinvest = 0;
        this.quantitys = data.quantitys;
        this.quantitysvalue = "全部项目金额";
        this.selectquantity = 0;
        this.shares = data.shares;
        this.sharesvalue = "全部股权比例";
        this.selectshare = 0;

        //全部经济体：经济体countrys、地区areas、经济组织groups、一带一路国家和地区ydylCountrys
        this.optionData = data.countrys;
        this.optionData1 = data.areas;
        this.optionData2 = data.groups;
        this.optionData3 = data.ydylCountrys;

        this.$refs.seleTree.valueTitle = "全部经济体"; //初始化下拉文本值
        this.countryid = 0; //初始化下拉值

        this.initChartgeo(); //流向图geoCoord
        this.getYearInfo(); //图1
        this.getSectorfo().then(() => {
          this.option2.title[0].text =
            "（全部投资，全部项目金额，全部股权比例）";
        });
        this.getAreaInfo().then(() => {
          this.option3.title[0].text =
            "（全部投资，全部项目金额，全部股权比例）";
        });
        this.getTop10Data().then(() => {
          this.option4.title[0].text =
            "（全部投资，全部项目金额，全部股权比例）";
        });
        this.getFactValueByQuantity(); //图5
        this.getFactValueByShare(); //图6
        this.getFactValueByGreen(); //图7
        this.chartevent();
        this.investsname = "全部投资";
        this.quantitysname = "全部项目金额";
        this.sharesname = "全部股权比例";
      }
    },
    // 重置用到
    async againSelect2() {
      const { code, data } = await api.get("/cgitController/getDbInfo", {
        dbid: this.databaseid
      });
      if (code === 0) {
        this.sectors = data.sectors; //下拉值
        this.sectorsvalue = "全部行业";
        this.selectsector = 0; //下拉选择值，默认全部即0
        if (this.selectsector === 0) {
          this.sectorsname = "全部";
        }
        this.years = data.years;
        this.yearsvalue = data.years[0].name + "";
        this.selectyear = data.years[0].name + "";
        this.invests = data.green;
        this.investsvalue = "全部投资";
        this.selectinvest = 0;
        this.quantitys = data.quantitys;
        this.quantitysvalue = "全部项目金额";
        this.selectquantity = 0;
        this.shares = data.shares;
        this.sharesvalue = "全部股权比例";
        this.selectshare = 0;

        //全部经济体：经济体countrys、地区areas、经济组织groups、一带一路国家和地区ydylCountrys
        this.optionData = data.countrys;
        this.optionData1 = data.areas;
        this.optionData2 = data.groups;
        this.optionData3 = data.ydylCountrys;

        this.$refs.seleTree.valueTitle = "全部经济体"; //初始化下拉文本值
        this.countryid = 0; //初始化下拉值

        this.initChartgeo(); //流向图geoCoord
        this.getYearInfo(); //图1
        this.getSectorfo().then(() => {
          this.option2.title[0].text = "（全部项目金额）";
        });
        this.getAreaInfo().then(() => {
          this.option3.title[0].text = "（全部项目金额）";
        });
        this.getTop10Data().then(() => {
          this.option4.title[0].text = "（全部项目金额）";
        });
        this.getFactValueByQuantity(); //图5
        this.getFactValueByShare(); //图6
        this.getFactValueByGreen(); //图7
        this.chartevent();
        this.quantitysname = "全部项目金额";
      }
    },
    // 加载数据
    loaddata() {
      this.initChartgeo(); //流向图geoCoord

      this.getYearInfo(); //图1
      this.getSectorfo(); //图2
      this.getAreaInfo(); //图3
      this.getTop10Data(); //图4
      this.getFactValueByQuantity(); //图5
      this.getFactValueByShare(); //图6
      this.getFactValueByGreen(); //图7
    },
    //流向图geoCoord
    async initChartgeo() {
      const { code, data } = await api.get("/cgitController/getGeoMapData", {
        dbType: 1,
        country: this.countryid,
        dbId: this.databaseid,
        sector: this.selectsector,
        year: this.selectyear,
        greenField: this.selectinvest,
        quantity: this.selectquantity,
        shareSize: this.selectshare
      });
      if (code === 0) {
        this.geoCoordMapdata = data;
        for (let key in this.geoCoordMapdata) {
          let coordX = this.geoCoordMapdata[key][0];
          if (coordX <= -30) {
            this.geoCoordMapdata[key][0] = 360 + coordX;
          }
        }
        this.initChart(); //流向图，因为需要保证this.geoCoordMapdata有值才能显示流向图
      }
    },
    //流向图
    async initChart() {
      const { code, data } = await api.post("/cgitController/getTradeInfo", {
        country: this.countryid,
        queryType: this.tabnum,
        dbId: this.databaseid,
        sector: this.selectsector,
        year: this.selectyear,
        greenField: this.selectinvest,
        quantity: this.selectquantity,
        shareSize: this.selectshare
      });
      if (code === 0) {
        this.worldData = data;
      }

      let chartmap = this.$echarts.init(document.getElementById("myEchart"));

      //随屏幕大小缩放
      window.onresize = () => {
        chartmap.resize();
      };
      this.chart = echarts.init(this.$refs.myEchart);

      initCharts(this.chart, this.worldData, this.geoCoordMapdata); //world_CGIT.js
    },
    //流向图表格下载
    async downloadexcel() {
      var url = "../../cgitdownloaddata.xlsx"; //放在public目录下的文件可以直接访问
      window.location.href = url;
    },
    //全球投资金额(按年份)--图1
    async getYearInfo() {
      const { code, data } = await api.get("/cgitController/getYearInfo", {
        dbid: this.databaseid,
        country: this.countryid,
        queryType: this.tabnum,
        sector: this.selectsector,
        year: this.selectyear,
        greenField: this.selectinvest,
        quantity: this.selectquantity,
        shareSize: this.selectshare
      });
      if (code === 0) {
        this.option1.xAxis.data = data.lineChart.year;
        this.option1.series[0].data = data.lineChart.data;

        //重新处理集合为了算出百分比
        data.pieChart.forEach(element => {
          let datas = [];
          let total = 0;
          element.data.forEach(dataElement => {
            total += dataElement.value;
          });
          element.data.forEach(dataElement => {
            datas.push({
              name: dataElement.name,
              value: dataElement.value,
              percent: ((dataElement.value / total) * 100).toFixed(1)
            });
          });
          this.alloption1data.push({ year: element.year, data: datas });
        });
        this.option1.series[1].data = this.alloption1data[
          this.alloption1data.length - 1
        ].data;

        let maxyear = data.lineChart.year[data.lineChart.year.length - 1];
        // this.option1.series[1].label.formatter = "{b}: {@" + maxyear + "} ({d}%)";//之前没有三位分隔符的时候
        this.option1.series[1].encode.value = maxyear;
        this.option1.series[1].encode.tooltip = maxyear;

        if (data.lineChart.data.length == 0) {
          //无数据时显示默认饼图
          this.chart1_1 = false;
          this.chart1_2 = true;
        } else {
          this.chart1_1 = true;
          this.chart1_2 = false;
        }
      }
    },
    //全球投资金额(按行业)--图2
    async getSectorfo() {
      const { code, data } = await api.post("/cgitController/getSectorinfo", {
        country: this.countryid,
        dbId: this.databaseid,
        queryType: this.tabnum,
        sector: this.selectsector,
        year: this.selectyear,
        greenField: this.selectinvest,
        quantity: this.selectquantity,
        shareSize: this.selectshare
      });
      if (code === 0) {
        this.option2sub = data.subData;
        this.option2.xAxis[0].data = data.sectorData.sector;
        this.option2.series[0].data = data.sectorData.data;

        if (this.databaseid == 1)
          this.option2.title[0].text =
            "（" +
            this.investsname +
            "，" +
            this.quantitysname +
            "，" +
            this.sharesname +
            "）";
        else this.option2.title[0].text = "（" + this.quantitysname + "）"; //工程项目库、失败项目库，只显示项目金额

        if (data.sectorData.data.length == 0) {
          //无数据时显示默认饼图
          this.chart2_1 = false;
          this.chart2_2 = true;
        } else {
          this.chart2_1 = true;
          this.chart2_2 = false;
        }
      }
    },
    //全球投资金额(按地区)--图3
    async getAreaInfo() {
      const { code, data } = await api.post("/cgitController/getAreaInfo", {
        country: this.countryid,
        dbId: this.databaseid,
        queryType: this.tabnum,
        sector: this.selectsector,
        year: this.selectyear,
        greenField: this.selectinvest,
        quantity: this.selectquantity,
        shareSize: this.selectshare
      });
      if (code === 0) {
        this.option3sub = data.stateData;
        this.option3.xAxis[0].data = data.areaData.names;
        this.option3.series[0].data = data.areaData.values;

        if (this.databaseid == 1)
          this.option3.title[0].text =
            "（" +
            this.investsname +
            "，" +
            this.quantitysname +
            "，" +
            this.sharesname +
            "）";
        else this.option3.title[0].text = "（" + this.quantitysname + "）"; //工程项目库、失败项目库，只显示项目金额

        if (data.areaData.values.length == 0) {
          //无数据时显示默认饼图
          this.chart3_1 = false;
          this.chart3_2 = true;
        } else {
          this.chart3_1 = true;
          this.chart3_2 = false;
        }
      }
    },
    //投资方前10名--图4
    async getTop10Data() {
      const { code, data } = await api.post("/cgitController/getTop10Data", {
        country: this.countryid,
        dbId: this.databaseid,
        queryType: this.tabnum,
        sector: this.selectsector,
        year: this.selectyear,
        greenField: this.selectinvest,
        quantity: this.selectquantity,
        shareSize: this.selectshare
      });
      if (code === 0) {
        this.option4.series[0].data = data.data;
        this.option4.yAxis[0].data = data.investor;

        if (this.databaseid == 1)
          this.option4.title[0].text =
            "（" +
            this.investsname +
            "，" +
            this.quantitysname +
            "，" +
            this.sharesname +
            "）";
        else this.option4.title[0].text = "（" + this.quantitysname + "）"; //工程项目库、失败项目库，只显示项目金额

        if (data.data.length <= 10) {
          this.option4topnum = data.data.length;
        }

        if (data.data.length == 0) {
          //无数据时显示默认饼图
          this.chart4_1 = false;
          this.chart4_2 = true;
        } else {
          this.chart4_1 = true;
          this.chart4_2 = false;
        }

        //标题比较长的调整字体大小
        if (
          (
            this.selectyear +
            "年中国对" +
            this.charttitle4_1 +
            this.charttitle4_2 +
            this.charttitle4_3 +
            "TOP" +
            this.option4topnum +
            this.charttitle4_5 +
            this.charttitle4_6
          ).length >= 35
        )
          $("#chart4_1_h1").css("font-size", "12px");
        else $("#chart4_1_h1").css("font-size", "15px");
      }
    },
    //不同投资额区间的项目数量--图5
    async getFactValueByQuantity() {
      const { code, data } = await api.post(
        "/cgitController/getFactValueByQuantity",
        {
          country: this.countryid,
          dbId: this.databaseid,
          queryType: this.tabnum,
          sector: this.selectsector,
          year: this.selectyear,
          greenField: this.selectinvest,
          quantity: this.selectquantity,
          shareSize: this.selectshare
        }
      );
      if (code === 0) {
        this.option5.legend.data = data.quantity;
        this.option5.series[0].data = data.data;

        if (data.data.length == 0) {
          //无数据时显示默认饼图
          this.pieDisplay1_1 = false;
          this.pieDisplay1_2 = true;
        } else {
          this.pieDisplay1_1 = true;
          this.pieDisplay1_2 = false;
        }

        //标题比较长的调整字体大小
        if (
          (
            this.selectyear +
            "年中国" +
            this.charttitle5_1 +
            this.charttitle5_2 +
            "直接投资规模分布（按项目个数）"
          ).length >= 25
        )
          $("#chart5_h1").css("font-size", "12px");
        else $("#chart5_h1").css("font-size", "15px");
      }
    },
    //控股比例--图6
    async getFactValueByShare() {
      const { code, data } = await api.post(
        "/cgitController/getFactValueByShare",
        {
          country: this.countryid,
          dbId: this.databaseid,
          queryType: this.tabnum,
          sector: this.selectsector,
          year: this.selectyear,
          greenField: this.selectinvest,
          quantity: this.selectquantity,
          shareSize: this.selectshare
        }
      );
      if (code === 0) {
        this.option6.legend.data = data.share;
        this.option6.series[0].data = data.data;

        if (data.data.length == 0) {
          //无数据时显示默认饼图
          this.pieDisplay2_1 = false;
          this.pieDisplay2_2 = true;
        } else {
          this.pieDisplay2_1 = true;
          this.pieDisplay2_2 = false;
        }

        //标题比较长的调整字体大小
        if (
          (
            this.selectyear +
            "年中国" +
            this.charttitle6_1 +
            this.charttitle6_2 +
            "直接投资股权占比（按项目个数）"
          ).length >= 25
        )
          $("#chart6_h1").css("font-size", "12px");
        else $("#chart6_h1").css("font-size", "15px");
      }
    },
    //绿地投资--图7
    async getFactValueByGreen() {
      const { code, data } = await api.post(
        "/cgitController/getFactValueByGreen",
        {
          country: this.countryid,
          dbId: this.databaseid,
          queryType: this.tabnum,
          sector: this.selectsector,
          year: this.selectyear,
          greenField: this.selectinvest,
          quantity: this.selectquantity,
          shareSize: this.selectshare
        }
      );
      if (code === 0) {
        this.option7.legend.data = data.category;
        this.option7.series[0].data = data.data;

        if (data.data.length == 0) {
          //无数据时显示默认饼图
          this.pieDisplay3_1 = false;
          this.pieDisplay3_2 = true;
        } else {
          this.pieDisplay3_1 = true;
          this.pieDisplay3_2 = false;
        }

        //标题比较长的调整字体大小
        if (
          (
            this.selectyear +
            "年中国" +
            this.charttitle7_1 +
            this.charttitle7_2 +
            "直接投资中绿地投资项目占比（按项目个数）"
          ).length >= 25
        )
          $("#chart7_h1").css("font-size", "12px");
        else $("#chart7_h1").css("font-size", "15px");
      }
    },
    //绘制chart图
    chartevent() {
      let chart1 = this.$echarts.init(document.getElementById("chart1"));
      let chart2 = this.$echarts.init(document.getElementById("chart2"));
      let chart3 = this.$echarts.init(document.getElementById("chart3"));
      let chart8 = this.$echarts.init(document.getElementById("chart8"));
      let chartfullscreen = this.$echarts.init(
        document.getElementById("chartfullscreen")
      );

      //线饼图
      chart1.on("updateAxisPointer", event => {
        let xAxisInfo = event.axesInfo[0];
        if (xAxisInfo) {
          let dimension = xAxisInfo.value + 1;

          chart1.setOption({
            series: {
              id: "pie",
              label: {
                //formatter: "{b}: {@[" + dimension + "]} ({d}%)"
                formatter: function(params) {
                  //三位分隔法
                  var intPartFormat = params.value
                    .toString()
                    .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
                  return (
                    params.name +
                    "：" +
                    intPartFormat +
                    "(" +
                    params.percent +
                    "%)"
                  );
                }
              },
              data: this.alloption1data[dimension - 1].data,
              encode: {
                value: dimension,
                tooltip: dimension
              }
            }
          });
        }
      });
      //全屏线饼图
      chartfullscreen.on("updateAxisPointer", params => {
        if (params.dataIndex != undefined) {
          let dimension = params.dataIndex + 1;

          chartfullscreen.setOption({
            series: {
              id: "pie",
              label: {
                //formatter: "{b}: {@[" + dimension + "]} ({d}%)"
                formatter: function(params) {
                  //三位分隔法
                  var intPartFormat = params.value
                    .toString()
                    .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
                  return (
                    params.name +
                    "：" +
                    intPartFormat +
                    "(" +
                    params.percent +
                    "%)"
                  );
                }
              },
              data: this.alloption1data[dimension - 1].data,
              encode: {
                value: dimension,
                tooltip: dimension
              }
            }
          });
        }
      });

      //柱图2下钻
      chart2.on("click", params => {
        if (this.countryname == "") {
          this.countryname = "全部";
        }
        let seriesname = params.name;
        this.option8.color = "#FB4C50";
        //下钻标题
        this.alerttitle =
          this.selectyear +
          "年中国对" +
          this.charttitle2_1 +
          this.charttitle2_2 +
          "的行业分布（" +
          seriesname +
          "行业）";
        this.option2sub.forEach(item => {
          if (item.sector === seriesname) {
            this.option8.title[1].text = "单位：亿美元";
            this.option8.title[1].x = "right";
            this.option8.title[1].padding = [0, 45, 0, 0];
            this.option8.title[1].textStyle.fontSize = 12;
            this.option8.title[1].textStyle.fontWeight = "normal";
            if (this.databasename === "投资") {
              this.option8.title[0].text =
                "（" +
                this.investsname +
                "，" +
                this.quantitysname +
                "，" +
                this.sharesname +
                "）";
            } else {
              this.option8.title[0].text = "（" + this.quantitysname + "）";
            }

            this.option8.xAxis[0].data = item.data.name;
            this.option8.series[0].data = item.data.value;
            this.boxDisplay = "block";
            chart8.setOption(this.option8);
          }
        });
      });
      //柱图3下钻
      chart3.on("click", params => {
        let seriesname = params.name;
        this.option8.color = "#009ACD";
        //下钻标题
        this.alerttitle =
          this.selectyear +
          "年中国" +
          this.charttitle3_0 +
          "对外" +
          this.charttitle3_1 +
          "的区域分布（" +
          seriesname +
          "地区）";

        this.option3sub.forEach(item => {
          if (item.area === seriesname) {
            this.option8.title[1].text = "单位：亿美元";
            this.option8.title[1].x = "right";
            this.option8.title[1].padding = [0, 45, 0, 0];
            this.option8.title[1].textStyle.fontSize = 12;
            this.option8.title[1].textStyle.fontWeight = "normal";
            // debugger
            if (this.databasename === "投资") {
              this.option8.title[0].text =
                "（" +
                this.investsname +
                "，" +
                this.quantitysname +
                "，" +
                this.sharesname +
                "）";
            } else {
              this.option8.title[0].text = "（" + this.quantitysname + "）";
            }

            this.option8.xAxis[0].data = item.data.names;
            this.option8.series[0].data = item.data.values;
            this.boxDisplay = "block";
            chart8.setOption(this.option8);
          }
        });
      });
      //全屏下钻
      chartfullscreen.on("click", params => {
        let seriesname = params.name;

        if (this.fullscreenoptionid === "2") {
          this.option8.color = "#FB4C50";
          //下钻标题
          this.alerttitle =
            this.selectyear +
            "年中国对" +
            this.charttitle2_1 +
            this.charttitle2_2 +
            "的行业分布（" +
            seriesname +
            "行业）";
          // this.option8.title[1].text =
          //   this.selectyear + "年中国全球投资金额（按投资领域划分）";
          this.option2sub.forEach(item => {
            if (item.sector === seriesname) {
              this.option8.xAxis[0].data = item.data.name;
              this.option8.series[0].data = item.data.value;
              this.boxDisplay = "block";
              chart8.setOption(this.option8);
            }
          });
        } else if (this.fullscreenoptionid === "3") {
          this.option8.color = "#0099ff";
          //下钻标题
          this.alerttitle =
            this.selectyear +
            "年中国" +
            this.charttitle3_0 +
            "对外" +
            this.charttitle3_1 +
            "的区域分布（" +
            seriesname +
            "地区）";
          // this.option8.title[1].text =
          //   this.selectyear + "年中国全球投资金额（按地区划分）";
          this.option3sub.forEach(item => {
            if (item.area === seriesname) {
              this.option8.xAxis[0].data = item.data.names;
              this.option8.series[0].data = item.data.values;
              this.boxDisplay = "block";
              chart8.setOption(this.option8);
            }
          });
        }
      });
    },
    //柱图下钻弹出框关闭
    closeAlert() {
      this.boxDisplay = "none";
    },
    //全屏
    openFullscreen(optionid) {
      this.searchBarFixed = false; //下拉框搜索取消固定
      this.showAlertBox = true;
      this.isOpen = true;
      this.fullscreenoptionid = optionid;

      //随屏幕大小缩放
      let chartfullscreen = this.$echarts.init(
        document.getElementById("chartfullscreen")
      );
      window.onresize = () => {
        chartfullscreen.resize();
      };

      //根据参数optionid判断要放大哪个图
      let thisoption;
      if (optionid === "1") {
        this.fullscreentitie =
          "中国对外" + this.charttitle1 + this.charttitle4_6;
        thisoption = this.option1;
      } else if (optionid === "2") {
        this.fullscreentitie =
          this.selectyear +
          "年中国对" +
          this.charttitle2_1 +
          this.charttitle2_2 +
          "的行业分布";
        thisoption = this.option2;
      } else if (optionid === "3") {
        this.fullscreentitie =
          this.selectyear +
          "年中国" +
          this.charttitle3_0 +
          "对外" +
          this.charttitle3_1 +
          "的区域分布";
        thisoption = this.option3;
      } else if (optionid === "4") {
        this.fullscreentitie =
          this.selectyear +
          "年中国对" +
          this.charttitle4_1 +
          this.charttitle4_2 +
          this.charttitle4_3 +
          "TOP" +
          this.option4topnum +
          "的" +
          this.charttitle4_5 +
          this.charttitle4_6;
        this.option4.series[0].barWidth = 30;
        thisoption = this.option4;
      } else if (optionid === "5") {
        //设置放大后饼的各个样式
        this.option5.legend.left = "center";
        this.option5.legend.top = "5%";
        this.option5.legend.orient = "horizontal";
        this.option5.radius = "80%";
        this.option5.series[0].center = ["50%", "50%"];
        this.fullscreentitie =
          this.selectyear +
          "年中国" +
          this.charttitle5_1 +
          this.charttitle5_2 +
          "直接投资规模分布（按项目个数）";
        thisoption = this.option5;
      } else if (optionid === "6") {
        this.option6.legend.left = "center";
        this.option6.legend.top = "5%";
        this.option6.legend.orient = "horizontal";
        this.option6.radius = "80%";
        this.option6.series[0].center = ["50%", "50%"];
        this.fullscreentitie =
          this.selectyear +
          "年中国" +
          this.charttitle6_1 +
          this.charttitle6_2 +
          "直接投资股权占比（按项目个数）";
        thisoption = this.option6;
      } else if (optionid === "7") {
        this.option7.legend.left = "center";
        this.option7.legend.top = "5%";
        this.option7.legend.orient = "horizontal";
        this.option7.radius = "80%";
        this.option7.series[0].center = ["50%", "50%"];
        this.fullscreentitie =
          this.selectyear +
          "年中国" +
          this.charttitle7_1 +
          this.charttitle7_2 +
          "直接投资中绿地投资项目占比（按项目个数）";
        thisoption = this.option7;
      }

      chartfullscreen.clear(); //清除，不然会多个图重叠

      this.timer = setTimeout(() => {
        chartfullscreen.setOption(thisoption);
        //设置延迟执行
        chartfullscreen.setOption({
          tooltip: {
            trigger: "axis",
            // show: true,
            axisPointer: {
              type: "none"
            }
          },

          grid: { bottom: "10%" }
          // series: [{ label: { show: true, position: "top" } }]
        });
      }, 1000);
    },
    //关闭全屏
    closeFullscreen() {
      // 恢复放大前样式
      this.option4.series[0].barWidth = 10;
      this.option5.legend.left = this.option6.legend.left = this.option7.legend.left =
        "left";
      this.option5.legend.top = this.option6.legend.top = this.option7.legend.top =
        "0%";
      this.option5.legend.orient = this.option6.legend.orient = this.option7.legend.orient =
        "horizontal";
      this.option5.radius = this.option6.radius = this.option7.radius = "55%";
      this.option5.series[0].center = this.option6.series[0].center = this.option7.series[0].center = [
        "50%",
        "50%"
      ];

      this.showAlertBox = false;
      this.isOpen = false;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  computed: {},
  components: {
    Top,
    Footer,
    cChart,
    SelectTree,
    backTop
  },
  watch: {}
};
</script>

<style lang='less' scoped>
/deep/.guides {
  display: none !important;
}
// 子库切换
.obor {
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);
  background: #fff;
  height: 55px;
  position: relative;
  .title {
    position: absolute;
    .nav_tab li {
      float: left;
      height: 55px;
      line-height: 55px;
      border-right: 1px solid #d7dfe3;
      span {
        color: #393c40;
        font-size: 15px;
        display: block;
        padding: 0 14px;
      }
      span:hover,
      .onhover {
        cursor: pointer;
        background: #4996dd;
        box-shadow: 5px 5px 5px #00649d inset;
        color: #fff;
        display: block;
      }
      span:checked {
        background: #4996dd;
        box-shadow: 5px 5px 5px #00649d inset;
        color: #fff;
        display: block;
      }
    }
  }
}

// tab切换
.obors {
  .bt_title {
    background: #fff;
    line-height: 55px;
    font-weight: 600;
    color: #1260af;
  }
}
// 下拉
// 下拉搜索固定
.searchBar {
  position: fixed;
  // background-color: #edf4f8;
  // background-color: #1fc1d1;
  background-color: #4ea9ee;
  top: 0;
  width: 99.5%;
  height: 48px;
  z-index: 9999;
}

.wrap {
  height: 34px;
  border: 0;
  position: relative;
}
.input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 100%;
  margin: 0;
  padding-left: 5px;
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  border: 1px solid #d7dfe3;
  box-sizing: border-box;
}
s {
  position: absolute;
  top: 1px;
  right: 0px;
  width: 32px;
  height: 32px;
  background: url(../../assets/imgs/arrow.png) no-repeat;
}
.m15 {
  box-sizing: border-box;
}
.width20 {
  max-width: 15.8%; //16.66%;
  width: 100%;
  padding: 0 5px;
}
.widthreset {
  max-width: 0%;
  width: 100%;
  padding: 0 5px;
}
.pt5 {
  padding-top: 5px !important;
}
.screenbox {
  height: 50px;
}
.screen {
  box-sizing: border-box;
  padding: 6px 0 5px 0;
}
.p5 {
  padding: 5px;
}
//所有区域下拉框
/deep/.el-input--suffix .el-input__inner {
  padding-right: 36px;
  height: 36px;
}

// 流向图
.bj_white2 {
  background: #fff;
  border: 1px solid #d7dfe3;
}
.mapbox,
flot_chart_wrapper {
  padding: 5px 10px;
  box-sizing: border-box;
}
// echart图
.w50 {
  width: 50%;
  padding: 0 5px;
  position: relative;
}
.w33 {
  width: 33.33%;
  padding: 0 5px;
  position: relative;
}
.card_title {
  background: url(../../assets/imgs/titlebj.png) repeat-x top;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #d7dfe3;
  border-left: 1px solid #d7dfe3;
  margin-left: -1px;
}
.card_title h1 {
  text-align: center;
  line-height: 45px;
  font-weight: 600;
  font-size: 0.95vw;
  font-size: 15px;
}
.mapboxdownload {
  padding: 0 0 10px 90%;
  background: #f8f8f8;
}
.mapboxsource {
  padding: 0 0 0 50px;
  float: left;
}

// 新增样式-CGIT
.el-select {
  width: 100%;
}
.el-input__inner_add {
  height: 36px;
}
.el-select .el-input .el-select__caret {
  margin-top: 2px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #4996dd !important;
  -webkit-box-shadow: 5px 5px 5px #00649d inset;
  box-shadow: 5px 5px 5px #00649d inset;
  color: #fff !important;
}

/* 柱图下钻弹出框 */
.content {
  width: 100%;
  height: 100%;
  position: relative;
}
.historySupBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  z-index: 99999;
}

.maskBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 1);
  opacity: 0.15;
  -khtml-opacity: 0.15;
  -moz-opacity: 0.15;
  -webkit-opacity: 0.15;
}

.historyAlertBox {
  width: 56.875vw;
  height: 51.481vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #edf4f8;
  border: 1px solid rgba(62, 139, 255, 0.59);
}

.historyAlertBox_close {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 3.012%;
  right: 2.012%;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFRkYxQkZEQjkxQTkxMUU5QUJDM0UxNDEzRDFGNjNEMSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFRkYxQkZEQzkxQTkxMUU5QUJDM0UxNDEzRDFGNjNEMSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkVGRjFCRkQ5OTFBOTExRTlBQkMzRTE0MTNEMUY2M0QxIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVGRjFCRkRBOTFBOTExRTlBQkMzRTE0MTNEMUY2M0QxIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+WIv32QAAALxJREFUeNpilOr4OZOBgeFE2o/2+QxEgFkclYlAypIJSJwE8aECxGiaDbKIudiG5fxZFtunIHEg/cT4z5ELBDSlAV03D2QjA4gBpNJx2YyuCSTGBJPEpRnKnoWsCQRYkE0GSQAVMkA1w/WCDETWhGIjFpvnQDGGJqwaoeA/DjZujUh+SoVirAHGhEMT2Hn4QpsJlyZCoc2ETxMOzUkgMUZgWsWrCc0rIE2gtJ0O0jgLmsjnEZnIQZotAAIMAN1lct1JnsMEAAAAAElFTkSuQmCC)
    no-repeat;
  cursor: pointer;
  z-index: 10;
}

// 放大
.full_box {
  position: absolute;
  right: 20px;
  top: 55px;
}
.fullscreentitle {
  text-align: center;
  line-height: 45px;
  font-weight: 600;
  font-size: 0.95vw;
  font-size: 18px;
}
// 放大按钮
.zoomBtn {
  position: absolute;
  content: "";
  display: block;
  height: 21px;
  width: 21px;
  background: url(../../assets/imgs/fdimg.png) no-repeat;
  top: 13px;
  right: 10px;
  cursor: pointer;
  z-index: 10;
}
// 缩小按钮
.narrowBtn {
  position: absolute;
  content: "";
  display: block;
  height: 32px;
  width: 32px;
  background: url(../../assets/imgs/sximg.png) no-repeat;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 10;
}
// 放大层
.alertBox {
  position: fixed;
  z-index: 999999;
  top: 0px;
  left: 0px;
  background: #edf4f8; //#4996dd;
  opacity: 1;
  .alertBigBox_close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
}

// 放大动画效果
@keyframes open {
  0% {
    height: 0px;
    width: 0%;
  }
  100% {
    height: 100vh;
    width: 100%;
  }
}
.open {
  animation: open 1s forwards;
}
//图2-3下钻标题
.alerttitle {
  font-size: 16px;
  color: #000;
  margin-top: 10px;
  font-weight: bolder;
}

// 子库切换
/*悬窗*/
.izl-rmenu {
  position: fixed;
  left: 0;
  bottom: 230px;
  padding-bottom: 73px;
  z-index: 999;
}

.izl-rmenu .btn {
  width: 80px;
  padding-bottom: 17px;
  padding-top: 17px;
  margin-bottom: 1px;
  cursor: pointer;
  position: relative;
  text-align: center;
}

.izl-rmenu .btn span {
  color: #fff;
  font-size: 15px;
  display: block;
  padding: 0 5px;
  line-height: 18px;
}

.izl-rmenu .btn img {
  padding-bottom: 5px;
  margin: 0 auto;
}

.izl-rmenu .btntext {
  background: rgba(43, 153, 236, 0.8);
  height: 70px;
}
.izl-rmenu .btntext .btntextspan {
  line-height: 35px;
}

.izl-rmenu .btntext:hover {
  -moz-box-shadow: 5px 5px 5px rgba(5, 6, 7, 0.8) inset; /* For Firefox3.6+ */
  -webkit-box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Chrome5+, Safari5+ */
  box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Latest Opera */
}

.izl-rmenu .btntext1:hover {
  background: rgba(12, 85, 141, 0.8);
}

.izl-rmenu .btntext2:hover {
  background: rgba(12, 85, 141, 0.8);
  // background: #09a2cb;
}

.izl-rmenu .btntext3:hover {
  background: rgba(12, 85, 141, 0.8);
  // background: #0084e6;
}

.izl-rmenu .on {
  /* For Latest Opera */
}

.izl-rmenu .on1 {
  background: rgba(12, 85, 141, 0.8);
  -moz-box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Firefox3.6+ */
  -webkit-box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Chrome5+, Safari5+ */
  box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset;
}

.izl-rmenu .on2 {
  // background: #09a2cb;
  background: rgba(12, 85, 141, 0.8);
  -moz-box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Firefox3.6+ */
  -webkit-box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Chrome5+, Safari5+ */
  box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset;
}

.izl-rmenu .on3 {
  // background: #0084e6;
  background: rgba(12, 85, 141, 0.8);
  -moz-box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Firefox3.6+ */
  -webkit-box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset; /* For Chrome5+, Safari5+ */
  box-shadow: 5px 5px 5px rgba(12, 85, 141, 0.8) inset;
}
</style>
